import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ResultsSearchService {
  _payload: any;
  _response: any[];
  _origin: string;

  // Subject para reloadSearchHotel
  private reloadSearchHotelSubject = new Subject<void>();
  reloadSearchHotel$ = this.reloadSearchHotelSubject.asObservable();

  constructor() { }

  _setPayload(payload: any) {
    this._payload = payload;
  }

  _setResponse(response: any, manyLocations?: any) {
    this._response = response;
  }

  _getPayload() {
    return this._payload;
  }

  _getResponse() {
    return this._response;
  }

  _setOrigin(origin: any) {
    this._origin = origin;
  }
  _getOrigin() {
    return this._origin;
  }

  // Método para emitir el reload
  emitReloadSearchHotel() {
    this.reloadSearchHotelSubject.next();
  }


}
